module.exports = __webpack_public_path__ + "static/img/honor4.ae778b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor4.png
// module id = GBSg
// module chunks = 0